/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CouponPay
 */
export interface CouponPay {
    /**
     * 账单ID
     * @type {number}
     * @memberof CouponPay
     */
    billId?: number;
    /**
     * 优惠券ID
     * @type {number}
     * @memberof CouponPay
     */
    couponId?: number;
    /**
     * 数量
     * @type {number}
     * @memberof CouponPay
     */
    quantity?: number;
    /**
     * 金额
     * @type {number}
     * @memberof CouponPay
     */
    amount?: number;
}

/**
 * Check if a given object implements the CouponPay interface.
 */
export function instanceOfCouponPay(value: object): value is CouponPay {
    return true;
}

export function CouponPayFromJSON(json: any): CouponPay {
    return CouponPayFromJSONTyped(json, false);
}

export function CouponPayFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponPay {
    if (json == null) {
        return json;
    }
    return {
        
        'billId': json['billId'] == null ? undefined : json['billId'],
        'couponId': json['couponId'] == null ? undefined : json['couponId'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function CouponPayToJSON(json: any): CouponPay {
    return CouponPayToJSONTyped(json, false);
}

export function CouponPayToJSONTyped(value?: CouponPay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billId': value['billId'],
        'couponId': value['couponId'],
        'quantity': value['quantity'],
        'amount': value['amount'],
    };
}

